import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CSSModules from 'react-css-modules';
import find from 'lodash/find';
import shouldUpdate from 'recompose/shouldUpdate';
import TableHeaderCell from './TableHeaderCell/TableHeaderCell_container';
import styles from './styles.scss';

const getColumns = (props) => {
  const {filters, cols, getData} = props;

  return (
	  cols.map((colData, idx) => {
		const filter = find(filters, {columnId: colData.key}) || null;

		return (
			<TableHeaderCell
				{...props}
				colData={colData}
				filter={filter}
				key={colData.key}
				onSortToggle={getData}
			/>
		);
	  })
  );
};


const TableHeader = (props) => {
  console.log('TableHeader render');
  return (
	  <table styleName="QualTableHeader">
		<tbody>
		<tr styleName="row">
		  {getColumns(props)}
		</tr>
		</tbody>
	  </table>
  );
};


TableHeader.displayName = 'TableHeaderComponent';

TableHeader.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.object).isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortDir: PropTypes.oneOf(['', 'asc', 'desc']).isRequired,
  getFilter: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  searchInFilter: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired
};

TableHeader.defaultProps = {
  cols: [],
  filters: [],
  sortDir: ''
};

const propsCheck = (props, nextProps) => {
  const {cols, filters, sortDir} = props;

  return (
	  JSON.stringify(cols) !== JSON.stringify(nextProps.cols) ||
	  JSON.stringify(filters) !== JSON.stringify(nextProps.filters) ||
	  JSON.stringify(sortDir) !== JSON.stringify(nextProps.sortDir)
  );

};


export default shouldUpdate(propsCheck)(CSSModules(TableHeader, styles));



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeader_component.js